import { api } from './api';

export interface StudentGnDTO {
  id: number;
  courseId: number;
  nodeId: number | null;
  afterNodeId: number | null;
  refName: string | null;
  blocks: string;
  viewPref: 'CANVAS' | 'PAGES';
  updatedAt: string;
  publishedAt: string | null;
  lastSeenPublishedAt: string | null;
}

/**
 * The student's private GN documents (spec 046, contracts/student-gn-api.md). The PUT save
 * is the single write path for all student content regardless of origin (FR-040).
 */
export async function getOrCreateTopicGn(courseId: number, nodeId: number): Promise<StudentGnDTO> {
  const response = await api.get<{ data: StudentGnDTO }>(`/api/student/gn/courses/${courseId}/nodes/${nodeId}`);
  return response.data.data;
}

export async function getGn(gnId: number): Promise<StudentGnDTO> {
  const response = await api.get<{ data: StudentGnDTO }>(`/api/student/gn/${gnId}`);
  return response.data.data;
}

export async function saveGn(gnId: number, blocks: string): Promise<void> {
  await api.put(`/api/student/gn/${gnId}`, { blocks });
}

export async function updateViewPref(gnId: number, viewPref: 'CANVAS' | 'PAGES'): Promise<void> {
  await api.put(`/api/student/gn/${gnId}/view`, { viewPref });
}

export async function markPublishedSeen(gnId: number): Promise<void> {
  await api.put(`/api/student/gn/${gnId}/seen-published`);
}

export async function createInterTopicGn(
  courseId: number,
  afterNodeId: number,
  refName: string,
): Promise<StudentGnDTO> {
  const response = await api.post<{ data: StudentGnDTO }>(
    `/api/student/gn/courses/${courseId}/inter-topic`,
    { afterNodeId, refName },
  );
  return response.data.data;
}

export async function listInterTopicGns(courseId: number): Promise<StudentGnDTO[]> {
  const response = await api.get<{ data: StudentGnDTO[] }>(`/api/student/gn/courses/${courseId}/inter-topic`);
  return response.data.data;
}

export async function renameInterTopicGn(gnId: number, refName: string): Promise<void> {
  await api.put(`/api/student/gn/${gnId}/ref-name`, { refName });
}

export async function deleteInterTopicGn(gnId: number): Promise<void> {
  await api.delete(`/api/student/gn/${gnId}`);
}
